// @ts-ignore
import React, { FC } from 'react'
import { SubmitHandler, useForm } from 'react-hook-form'
import tw from 'tailwind-styled-components'
import MainButton from '../common/util/input/MainButton'
import { Password } from '../inputs/Password'

export interface PasswordData {
    password: string
}

const Form = tw.form`grid grid-cols-2 gap-4 mb-8 items-center`

export const CheckPassword: FC<{ onSubmit: SubmitHandler<PasswordData> }> = ({
    onSubmit,
}) => {
    const {
        formState: { errors },
        register,
        handleSubmit,
    } = useForm<PasswordData>({
        defaultValues: {
            password: undefined,
        },
    })

    return (
        <div className={'w-1/2 p-8 m-auto'}>
            <Form onSubmit={handleSubmit(onSubmit)} onValid={() => {}}>
                <Password
                    register={register}
                    error={errors.image}
                    name="password"
                    placeholder="Password"
                    required
                    label="Password"
                />
                <div className={'mt-6'}>
                    <MainButton className="btn" type="submit">
                        Submit
                    </MainButton>
                </div>
            </Form>
        </div>
    )
}
